/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./LayoutWithLeftBlockMenu.vue?vue&type=template&id=6762ae37"
import script from "./LayoutWithLeftBlockMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./LayoutWithLeftBlockMenu.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports